var map = {
	"./PushpayLogo.svg": "2Kts",
	"./ach.svg": "9gBf",
	"./alert-exclamation-icon-encircled.svg": "CbvD",
	"./alert-exclamation-icon-fill.svg": "nal2",
	"./alert-exclamation-icon.svg": "uHoR",
	"./alert-icon-danger.svg": "GmI6",
	"./alert-icon-info.svg": "TN0a",
	"./alert-icon-success.svg": "W2Kk",
	"./alert-icon-warning.svg": "gvXY",
	"./all-givings-card.svg": "IOh8",
	"./amex.svg": "04hz",
	"./android.svg": "s+xA",
	"./apple.svg": "wsVV",
	"./arrow-right.svg": "Vgp3",
	"./arrow-short.svg": "mfzL",
	"./arrow-single.svg": "eYCh",
	"./bin.svg": "b1Ct",
	"./cabinet.svg": "2+mA",
	"./cal-white.svg": "+04s",
	"./cal.svg": "YzUi",
	"./calendar-red.svg": "J1Js",
	"./calendar.svg": "OZqd",
	"./campaigns.svg": "mfWr",
	"./cc.svg": "YUSm",
	"./cd-check.svg": "2JyM",
	"./centralchurch-text.svg": "zFEi",
	"./check-deposit.svg": "7i11",
	"./checkbox-indeterminate.svg": "HO2O",
	"./checkbox-ticked.svg": "r51D",
	"./close-card.svg": "r+sH",
	"./close-cross-small.svg": "6OWf",
	"./close-cross.svg": "CYj7",
	"./close.svg": "NXws",
	"./community-outline.svg": "vRMj",
	"./community.svg": "Gp98",
	"./configure-statements.svg": "pwf1",
	"./copy.svg": "klRi",
	"./dashboard.svg": "3nGn",
	"./delivery-plane.svg": "Drhd",
	"./discover.svg": "t7sC",
	"./drag-handle.svg": "2cMU",
	"./duplicate.svg": "SAxR",
	"./eye-slash.svg": "/jyK",
	"./eye.svg": "bvoo",
	"./filter.svg": "aaF1",
	"./flag-au.svg": "vLDt",
	"./flag-be.svg": "p+jE",
	"./flag-ca.svg": "Bh06",
	"./flag-ch.svg": "tUao",
	"./flag-de.svg": "3/sV",
	"./flag-dk.svg": "wC6w",
	"./flag-fi.svg": "s+JT",
	"./flag-gb.svg": "29tc",
	"./flag-is.svg": "nIdm",
	"./flag-lv.svg": "Ix8t",
	"./flag-mx.svg": "Czf7",
	"./flag-no.svg": "rwYQ",
	"./flag-nz.svg": "ZJUL",
	"./flag-se.svg": "IH4u",
	"./flag-us.svg": "OgM8",
	"./fund-add-tipbox-icon.svg": "vSu1",
	"./fund-reallocation-tipbox-icon.svg": "AYw/",
	"./fund-single-box.svg": "BDxy",
	"./fund-summary-tipbox-icon.svg": "GR7Q",
	"./funds-reverse.svg": "BIN/",
	"./funds.svg": "tGec",
	"./gear.svg": "o1Qy",
	"./generate-statements.svg": "5XrD",
	"./gift-entry-reverse.svg": "Bxw+",
	"./gift-entry.svg": "uvvi",
	"./giving-statement.svg": "BMkR",
	"./handwriting-arrow.svg": "1KdW",
	"./home.svg": "yBSO",
	"./hourglass.svg": "0HMU",
	"./icon-add.svg": "17/+",
	"./icon-chevron-left.svg": "XAAt",
	"./icon-chevron-right.svg": "jBGd",
	"./icon-clipboard.svg": "/u1w",
	"./icon-close-fund.svg": "FoaH",
	"./icon-confetti.svg": "K8+r",
	"./icon-delete.svg": "cH52",
	"./icon-deposit.svg": "9FE6",
	"./icon-double-chevron-left.svg": "EE26",
	"./icon-double-chevron-right.svg": "aNdC",
	"./icon-edit.svg": "28Q0",
	"./icon-error.svg": "XKaT",
	"./icon-feedback-group.svg": "LifU",
	"./icon-flip.svg": "H7Vi",
	"./icon-follow-link.svg": "6QlT",
	"./icon-heart-purple.svg": "Q1EN",
	"./icon-hourglass.svg": "zi2t",
	"./icon-info.svg": "qDYU",
	"./icon-link.svg": "rP2k",
	"./icon-migrated.svg": "2aJv",
	"./icon-paused.svg": "cpME",
	"./icon-print.svg": "55WH",
	"./icon-question.svg": "uMpc",
	"./icon-recurring.svg": "inkg",
	"./icon-refresh.svg": "7ZXa",
	"./icon-refund.svg": "D83Q",
	"./icon-reopen-fund.svg": "Ri3p",
	"./icon-report.svg": "ka80",
	"./icon-search.svg": "6gqj",
	"./icon-shuffle.svg": "XuWx",
	"./icon-sorting-down.svg": "OjF9",
	"./icon-sorting-up.svg": "wdlZ",
	"./icon-sorting.svg": "vl14",
	"./icon-spreadsheet.svg": "TyIs",
	"./icon-support.svg": "9q/5",
	"./icon-time.svg": "us3d",
	"./icon-tips.svg": "9n8w",
	"./icon-unlink.svg": "FVQV",
	"./icon-unread.svg": "qqwo",
	"./icon-xs-cross.svg": "nixf",
	"./icon-xs-gear.svg": "QR0x",
	"./id-tag.svg": "3u/c",
	"./image-placeholder.svg": "GzOg",
	"./ind-bang.svg": "f4Sq",
	"./ind-clock.svg": "z9lX",
	"./ind-cross.svg": "lDJp",
	"./ind-grey-tick.svg": "3vm7",
	"./ind-move.svg": "dRnG",
	"./ind-pause.svg": "exvW",
	"./ind-question.svg": "UuQ5",
	"./ind-recurring.svg": "5AvW",
	"./ind-red-recurring.svg": "PlgT",
	"./ind-tick.svg": "9Q/0",
	"./ind-transparent-tick.svg": "w15l",
	"./info-bell.svg": "N6NB",
	"./information.svg": "LlRu",
	"./insights.svg": "gUR1",
	"./invalid.svg": "UY0I",
	"./iphone8.svg": "9QTM",
	"./jpg.svg": "DyIV",
	"./laptop.svg": "P925",
	"./link-member.svg": "bomX",
	"./login-admin.svg": "kPcD",
	"./login-mobile.svg": "vLo5",
	"./login-personal.svg": "XPLh",
	"./loudspeaker.svg": "5dm8",
	"./mastercard.svg": "TrK4",
	"./member-fill.svg": "dT2m",
	"./member-organization.svg": "vIk2",
	"./member-outline.svg": "cIn+",
	"./mobile-rect.svg": "muCU",
	"./mobile.svg": "R99a",
	"./padlock.svg": "UdmC",
	"./paymentmethods.svg": "pbAd",
	"./paymentrequests.svg": "bVYK",
	"./pdf.svg": "BKSG",
	"./pen-white.svg": "KEhI",
	"./pen.svg": "o0n4",
	"./pencil.svg": "k0s4",
	"./phone.svg": "aI5z",
	"./plus.svg": "pNb4",
	"./pptx.svg": "T3iN",
	"./profile-plus.svg": "7RHO",
	"./profile.svg": "6MIw",
	"./psb.svg": "cr5/",
	"./psd.svg": "VL8I",
	"./pushpay-logo-footer.svg": "oJFk",
	"./pushpay-logo-grey-2.svg": "I7RS",
	"./pushpay-logo-grey.svg": "WW8e",
	"./pushpay-logo-header-mobile.svg": "LZZm",
	"./pushpay-logo-header.svg": "hG21",
	"./pushpay-logo-sidebar.svg": "D5nA",
	"./pushpay-logo.svg": "9MEj",
	"./pushpay-website-qr-code.svg": "oa4s",
	"./question.svg": "XC+K",
	"./quickbooks-logo.svg": "DrjK",
	"./reactivate.svg": "pMN8",
	"./reconciliation.svg": "7209",
	"./recurring.svg": "3VIj",
	"./security.svg": "Ft+n",
	"./send-statements.svg": "HFUO",
	"./share.svg": "8KrD",
	"./spinner.svg": "+1Pc",
	"./star-open.svg": "vO1J",
	"./star.svg": "ZieA",
	"./statements-downloaded.svg": "pDQG",
	"./statements-emailed.svg": "oAkb",
	"./statements-excluded.svg": "b1UA",
	"./step-complete-mobile.svg": "+T51",
	"./step-complete.svg": "twwn",
	"./support.svg": "xMqG",
	"./tax-label.svg": "M3CA",
	"./tax-statements.svg": "jcTP",
	"./tick.svg": "6wpu",
	"./tile-batch-entry.svg": "FX1G",
	"./tile-check-deposit.svg": "mklT",
	"./tile-single-entry.svg": "8WOw",
	"./transactions-transparent.svg": "QEi6",
	"./transactions.svg": "2Yur",
	"./trash.svg": "K8vd",
	"./unknown.svg": "woWc",
	"./unlink.svg": "Qfk0",
	"./visa.svg": "Agt4",
	"./vt-reverse.svg": "nvm+",
	"./vt-tax.svg": "FDdd",
	"./vt.svg": "ZyHm"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "/SF1";